export default "__VITE_ASSET__40ee2181__"